import { CKEditor } from '@ckeditor/ckeditor5-react';
import { faAngleDown, faAngleRight, faAngleUp, faArrowUpRightFromSquare, faCheckDouble, faEdit, faEnvelopeOpenText, faPlus, faPrint, faSave, faTimes, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import moment from 'moment';
import { Component } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { GET, POST } from '../../api';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { sendCloudMessage } from '../../helpers/cloud_message';
import { handleFormErrors } from '../../helpers/form_helpers';
import { t } from '../../helpers/translation_helper';
import Paginate from '../_partials/Paginate/_Paginate';
import AssessLogRow from './AssessLogRow';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import AssessmentDetailObservation from '../../pdf/AssessmentDetailObservation';
import AIGenerationButton from '../_common/AI/AIGenerationButton';
import AIGenerationModal from '../_common/AI/AIGenerationModal';

// API URL
const apiURL = process.env.REACT_APP_API_URL;
const assrepDomainAreaNotesDefault = {
  adan_id: 0,
  progass_id: '',
  learnarea_id: '',
  adan_comment: ''
}

class AssessRepCard extends Component {
  state = {
    working: false,
    working_assess_logs: false,
    working_more_comments: false,
    workingEmail: false,
    working_EmailSummaryObservation: false,
    working_EmailLearningJournal: false,
    assrep_main_comment_visible_modal: false,
    assrep_main_comment_visible: (this.props.data.AssrepMain.assrep_main_comment_visible == 1) ? true : false,
    showAssessmentLogs: false,
    assrep_main_comment_1: this.props.data.AssrepMain.assrep_main_comment_1,
    assrep_main_comment_2: this.props.data.AssrepMain.assrep_main_comment_2,
    assrep_main_comment_3: this.props.data.AssrepMain.assrep_main_comment_3,
    assrep_main_comment_4: this.props.data.AssrepMain.assrep_main_comment_4,
    assessLogs: [],
    assessLogslimit: 12,
    assessLogsTotalRecords: 0,
    showMoreCommentsModal: false,
    moreComments: null,
    assrep_posted: null,
    confirmModal: { show: false, id: 0, action: () => { }, message: '' },
    assrepDomainAreaNotesModal: false,
    assrepDomainAreaNotesData: [],
    assrepDomainAreaNotes: assrepDomainAreaNotesDefault,
    printPDFModal: {
      show: false,
      toggleModal: (data = null) => { this.setState({ printPDFModal: { ...this.state.printPDFModal, show: !this.state.printPDFModal.show, data } }) },
      data: null,
    },
    objectivesForAIPrompt: []
  }

  componentDidMount() {
    const { assrep_posted } = this.props.data.Assrep;
    this.setState({ assrep_posted: assrep_posted });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.AIContent &&
      (
        !prevProps.AIContent ||
        this.props.AIContent.key !== prevProps.AIContent.key ||
        this.props.AIContent.value !== prevProps.AIContent.value
      )
    ) {
      console.log('%cSTATE', 'color:blue;font-size:20px;');
      this.setState({
        assrepDomainAreaNotes: {
          ...this.state.assrepDomainAreaNotes,
          adan_comment: this.props.AIContent.value
        }
      });
    }
  }

  GetAssrepDomainAreaNotes = async () => {
    if (!this.state.assrepDomainAreaNotesModal) {
      this.setState({ assrepDomainAreaNotesData: [] })
      return false
    }
    const { Assrep, AssrepHeader, childData, AssrepMain } = this.props.data;
    const { assrep_main_id, assrepheader_id } = AssrepMain;
    if (this.GetAssrepDomainAreaNotesReq) {
      this.GetAssrepDomainAreaNotesReq.abort();
    }
    this.GetAssrepDomainAreaNotesReq = new AbortController();
    const res = await GET('assrep-domain-area-notes/get-list', {
      signal: this.GetAssrepDomainAreaNotesReq.signal,
      params: {
        assrep_main_id: assrep_main_id,
      }
    });
    if (res) {
      this.setState({ assrepDomainAreaNotesData: res.data })
    }
  };
  editAssrepDomainAreaNotes = (v) => {
    let assrepDomainAreaNotesNew = { ...assrepDomainAreaNotesDefault, ...v }
    assrepDomainAreaNotesNew.progass_id = (v.progass_id) ? { label: v.progass_code, value: v.progass_id } : null
    assrepDomainAreaNotesNew.learnarea_id = (v.learnarea_id) ? { label: v.learnarea_code, value: v.learnarea_id } : null
    this.setState({ assrepDomainAreaNotes: assrepDomainAreaNotesNew })
  }
  deleteAssrepDomainAreaNotes = async (v) => {
    if (this.deleteAssrepDomainAreaNotesReq) {
      this.deleteAssrepDomainAreaNotesReq.abort()
    }
    this.deleteAssrepDomainAreaNotesReq = new AbortController();

    const res = await GET('assrep-domain-area-notes/delete', {
      params: {
        adan_id: v.adan_id
      },
      signal: this.deleteAssrepDomainAreaNotesReq.signal
    });

    if (res) {
      let resData = res.data
      if (resData.type) {
        this.GetAssrepDomainAreaNotes()
        toast[resData.messageType](t(resData.message));
      }
    }
  }

  updateAssrep = async () => {

    this.setState({ working: true });

    const { authData } = this.props;
    const { auth_key } = authData.loginData;
    const { Assrep, AssrepHeader, childData, AssrepMain } = this.props.data;
    const { assrep_main_id } = AssrepMain;
    const { assrep_main_comment_1, assrep_main_comment_2, assrep_main_comment_3, assrep_main_comment_4, assrep_main_comment_visible } = this.state;

    const fData = new FormData();
    fData.append('assrep_main_id', assrep_main_id);
    fData.append('assrep_main_comment_1', assrep_main_comment_1);
    fData.append('assrep_main_comment_2', assrep_main_comment_2);
    fData.append('assrep_main_comment_3', assrep_main_comment_3);
    fData.append('assrep_main_comment_4', assrep_main_comment_4);
    fData.append('assrep_main_comment_visible', (assrep_main_comment_visible) ? 1 : 0);

    try {
      const res = await POST('student-tracker/update-assrep', fData);

      if (res.data.type) {
        toast.success(t(res.data.message));
      }

      this.setState({ working: false });

    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong!'));
      this.setState({ working: false });
    }

  }

  saveAssrepDomainAreaNotes = async () => {
    this.setState({ working: true });
    const { Assrep, AssrepHeader, childData, AssrepMain } = this.props.data;
    const { assrep_main_id, assrepheader_id } = AssrepMain;

    let { assrepDomainAreaNotes } = this.state;
    assrepDomainAreaNotes = { ...assrepDomainAreaNotes }
    assrepDomainAreaNotes.progass_id = (assrepDomainAreaNotes.progass_id) ? assrepDomainAreaNotes.progass_id.value : null
    assrepDomainAreaNotes.learnarea_id = (assrepDomainAreaNotes.learnarea_id) ? assrepDomainAreaNotes.learnarea_id.value : null
    assrepDomainAreaNotes.assrep_main_id = assrep_main_id
    assrepDomainAreaNotes.assrepheader_id = assrepheader_id

    const fData = new FormData();
    fData.append('AssrepDomainAreaNotes', JSON.stringify(assrepDomainAreaNotes));

    try {
      if (this.saveAssrepDomainAreaNotesReq) {
        this.saveAssrepDomainAreaNotesReq.abort()
      }
      this.saveAssrepDomainAreaNotesReq = new AbortController();

      const res = await POST('assrep-domain-area-notes/save', fData, {
        signal: this.saveAssrepDomainAreaNotesReq.signal
      });

      if (res) {
        let resData = res.data
        if (resData.type) {
          this.setState({ assrepDomainAreaNotes: assrepDomainAreaNotesDefault, working: false }, () => {
            this.GetAssrepDomainAreaNotes()
          })
          toast.success(t(resData.message));
        } else {
          this.setState({ working: false });
          if (resData.data) {
            handleFormErrors(resData.data)
          } else {
            toast.error(t('Something went wrong!'));
          }
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong!'));
      this.setState({ working: false });
    }
  }

  getAssesslogData = async (limit = this.state.assessLogslimit, offset = 0) => {

    this.setState({
      working_assess_logs: true,
      showAssessmentLogs: true,
      showMoreCommentsModal: false,
      assrep_main_comment_visible_modal: false,
      assrepDomainAreaNotesModal: false
    });

    const { authData } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;
    const { Assrep, AssrepHeader, childData } = this.props.data;
    const { assrep_id, assrepheader_id } = Assrep;

    try {
      const res = await GET('student-tracker/get-assesslog-data', {
        params: {
          search: '',
          order: null,
          dir: null,
          limit,
          offset,
          assrepheader_id,
          assrep_id,
        }
      });

      if (res.status == 200) {
        this.setState({
          working_assess_logs: false,
          assessLogs: res.data.data,
          assessLogsTotalRecords: parseInt(res.data.total_count),
        });
      }

    } catch (err) {
      console.log('err', err)

      toast.error(t('Something went wrong!'));
      this.setState({ working_assess_logs: false });
    }

  }

  getAssrepDetails = async () => {

    if (this.state.showMoreCommentsModal) {
      this.setState({
        showMoreCommentsModal: false,
        moreComments: null,
        assrep_main_comment_visible_modal: false,
        showAssessmentLogs: false,
        assrepDomainAreaNotesModal: false
      });
      return
    }

    this.setState({
      showMoreCommentsModal: true,
      moreComments: null,
      assrep_main_comment_visible_modal: false,
      showAssessmentLogs: false,
      assrepDomainAreaNotesModal: false
    });

    const { Assrep, AssrepHeader, childData, AssrepMain } = this.props.data;
    const { assrep_main_id, assrepheader_id } = AssrepMain;

    try {
      const res = await GET('student-tracker/get-assrep-details', {
        params: {
          assrepheader_id,
          assrep_main_id,
        }
      });

      if (res.status == 200) {
        this.setState({
          moreComments: res.data.map((v, i) => {
            return { ...v, open: false }
          })
        });
      }

    } catch (err) {
      console.log('err', err)

      toast.error(t('Something went wrong!'));
    }

  }

  addComment = () => {
    const comments = [...this.state.moreComments];
    comments.push({ assrep_detail_id: 0, assrep_detail_comment: '', open: true });
    this.setState({ moreComments: comments });
  }

  delComment = (index) => {
    const comments = [...this.state.moreComments];
    comments.splice(index, 1);
    this.setState({ moreComments: comments });
  }

  saveAssrepDetails = async () => {

    this.setState({ working_more_comments: true });

    const { authData } = this.props;
    const { auth_key, user_id } = authData.loginData;
    const { center_id, center_timezone } = authData.centerData;
    const { Assrep, AssrepHeader, childData, AssrepMain } = this.props.data;
    const { assrep_main_id, assrepheader_id } = AssrepMain;

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('center_timezone', center_timezone);
    fData.append('user_id', user_id);
    fData.append('assrep_main_id', assrep_main_id);
    fData.append('assrepheader_id', assrepheader_id);
    fData.append('assrep_details', JSON.stringify(this.state.moreComments));

    try {
      const res = await POST('student-tracker/save-assrep-details', fData);

      if (res.data.type) {
        toast.success(t(res.data.message));
      }

      this.setState({ working_more_comments: false });

    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong!'));
      this.setState({ working_more_comments: false });
    }

  }

  emailReport = async (type, working) => {
    this.setState({
      [working]: true,
      confirmModal: {
        ...this.state.confirmModal, show: true, id: this.props.data.Assrep.assrep_id, message: 'Publish and send Email', action: async () => {
          const { assrep_id, assrep_report_type } = this.props.data.Assrep;
          const { assrep_main_id, assrepheader_id } = this.props.data.AssrepMain;
          const { child_id, parent_id } = this.props.data.childData;

          let cDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
          let q_url = ''
          if (assrep_report_type == 'Detailed Observation') {
            q_url = 'pdfgenerator/assessment-detail-observation'
          }
          if (assrep_report_type == 'Summary Observation') {
            q_url = 'pdfgenerator/assessment-summary-observation'
          }
          if (assrep_report_type == 'Learning Journal') {
            q_url = 'pdfgenerator/assessment-learning-journal'
          }
          if (assrep_report_type == 'EY Report 1') {
            q_url = 'pdfgenerator/ey-report-1'
          }
          if (assrep_report_type == 'EY Report 2') {
            q_url = 'pdfgenerator/ey-report-2'
          }
          if (assrep_report_type == 'EY Report 3') {
            q_url = 'pdfgenerator/ey-report-3'
          }
          if (assrep_report_type == 'Progress Report') {
            q_url = 'pdfgenerator/ib-report'
          }


          try {
            const res = await GET('student-tracker/toggle-posting', {
              params: {
                child_id,
                parent_id,
                assrep_id,
                assrep_main_id,
                lang: this.props.defaultLanguage.lang_abv,
                assrep_posted: cDateTime,
                q_url
              }
            });
            if (res) {
              console.log('student-tracker/toggle-posting', res);
              if (res.data.type) {

                // SEND MAIL
                const res2 = await GET(type, {
                  params: {
                    assrepheader_id,
                    assrep_id,
                    assrep_main_id,
                    lang: this.props.defaultLanguage.lang_abv,
                    toggle_comment_page: this.state.assrep_main_comment_visible,
                    mail: true,
                  }
                });
                this.setState({
                  [working]: false,
                  assrep_posted: cDateTime, confirmModal: {
                    ...this.state.confirmModal, show: false
                  }
                });
                if (cDateTime) {
                  res.data.sendCloudMessages.map((v, i) => {
                    sendCloudMessage(v.user_id, v.title, v.body, v.data)
                  })
                }
              } else {
                this.setState({
                  [working]: false,
                  confirmModal: {
                    ...this.state.confirmModal, show: false
                  }
                });
              }
              toast[res.data.messageType](t(res.data.message));
            }
          } catch (err) {
            console.log(err);
            toast.error(t('Something went wrong!'));
            this.setState({
              [working]: false,
              confirmModal: {
                ...this.state.confirmModal, show: false
              }
            })
          }
        }
      }
    })
  }

  printReport = async (type, working) => {
    this.setState({
      [working]: true,
    })
    const { assrep_id, assrep_report_type, assrepheader_id } = this.props.data.Assrep;
    const { child_id, parent_id } = this.props.data.childData;
    let cDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
    let q_url = ''
    if (assrep_report_type == 'Detailed Observation') {
      q_url = 'pdfgenerator/assessment-detail-observation'
    }
    if (assrep_report_type == 'Summary Observation') {
      q_url = 'pdfgenerator/assessment-summary-observation'
    }
    if (assrep_report_type == 'Learning Journal') {
      q_url = 'pdfgenerator/assessment-learning-journal'
    }
    if (assrep_report_type == 'EY Report 1') {
      q_url = 'pdfgenerator/ey-report-1'
    }
    if (assrep_report_type == 'EY Report 2') {
      q_url = 'pdfgenerator/ey-report-2'
    }
    if (assrep_report_type == 'EY Report 3') {
      q_url = 'pdfgenerator/ey-report-3'
    }
    if (assrep_report_type == 'Progress Report') {
      q_url = 'pdfgenerator/ib-report'
    }

    try {
      const res2 = await GET(type, {
        params: {
          assrepheader_id,
          assrep_id,
          lang: this.props.defaultLanguage.lang_abv,
          toggle_comment_page: this.state.assrep_main_comment_visible,
        }
      });
      this.setState({
        [working]: false,
      }, () => {
        this.state.printPDFModal.toggleModal(res2.data)
      });
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
      this.setState({
        [working]: false,
      })
    }
  }

  postingToggle = async () => {
    const { assrep_posted } = this.state;
    this.setState({
      confirmModal: {
        ...this.state.confirmModal, show: true, id: this.props.data.Assrep.assrep_id, message: (assrep_posted) ? 'Confirm Un-Publish' : 'Confirm Publish', action: async () => {
          const { assrep_id, assrep_report_type } = this.props.data.Assrep;
          const { assrep_main_id } = this.props.data.AssrepMain;
          const { child_id, parent_id } = this.props.data.childData;

          let cDateTime = null;
          if (assrep_posted) {
            cDateTime = null;
          } else {
            cDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
          }
          let q_url = ''
          if (assrep_report_type == 'Detailed Observation') {
            q_url = 'pdfgenerator/assessment-detail-observation'
          }
          if (assrep_report_type == 'Summary Observation') {
            q_url = 'pdfgenerator/assessment-summary-observation'
          }
          if (assrep_report_type == 'Learning Journal') {
            q_url = 'pdfgenerator/assessment-learning-journal'
          }
          if (assrep_report_type == 'EY Report 1') {
            q_url = 'pdfgenerator/ey-report-1'
          }
          if (assrep_report_type == 'EY Report 2') {
            q_url = 'pdfgenerator/ey-report-2'
          }
          if (assrep_report_type == 'Progress Report') {
            q_url = 'pdfgenerator/ib-report'
          }

          try {
            const res = await GET('student-tracker/toggle-posting', {
              params: {
                child_id,
                parent_id,
                assrep_id,
                assrep_main_id,
                assrep_posted: cDateTime,
                q_url
              }
            });
            if (res) {
              console.log('student-tracker/toggle-posting', res);
              if (res.data.type) {
                this.setState({
                  assrep_posted: cDateTime, confirmModal: {
                    ...this.state.confirmModal, show: false
                  }
                });
                if (cDateTime) {
                  res.data.sendCloudMessages.map((v, i) => {
                    sendCloudMessage(v.user_id, v.title, v.body, v.data)
                  })
                }
              } else {
                this.setState({
                  confirmModal: {
                    ...this.state.confirmModal, show: false
                  }
                });
              }
              toast[res.data.messageType](t(res.data.message));
            }
          } catch (err) {
            console.log(err);
            toast.error(t('Something went wrong!'));
            this.setState({
              confirmModal: {
                ...this.state.confirmModal, show: false
              }
            })
          }
        }
      }
    })
  }

  generatePDF = () => {
    html2canvas(document.querySelector("#printPDFModal"), {
      useCORS: true,
      // foreignObjectRendering: true,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4',
      });
      const imgWidth = 447;
      const pageHeight = pdf.internal.pageSize.getHeight();//631.4175px
      const pageWidth = pdf.internal.pageSize.getWidth();// 446.46px
      console.log('pageHeight', pageHeight, pageWidth);

      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const totalPageSize = Math.ceil(imgHeight / pageHeight);
      let yPosition = 0;
      pdf.addImage(imgData, 'PNG', 0, yPosition, imgWidth, imgHeight);
      for (let pageIndex = 1; pageIndex < totalPageSize; pageIndex++) {
        // making it negative to crop the image
        // and adding 10 because of the initial padding
        yPosition = pageIndex * pageHeight * -1;
        pdf.addPage();
        pdf.addImage(
          imgData,
          'PNG',
          0,
          yPosition,
          imgWidth,
          imgHeight
        );
      }
      pdf.save("TEST.pdf");
    });
  }

  getAssesslogs = async () => {
    const { AssrepMain, Assrep } = this.props.data;
    const { assrepheader_id } = AssrepMain;
    const { assrep_id, } = Assrep;

    const { assrepDomainAreaNotes } = this.state;
    const { learnarea_id } = assrepDomainAreaNotes;
    const { learnarea_id: learnarea_id_value } = learnarea_id;

    try {
      const res = await GET('student-tracker/get-assesslogs', {
        params: {
          learnarea_id: learnarea_id_value,
          assrepheader_id,
          assrep_id
        }
      });

      if (res.status === 200) {
        this.setState({
          objectivesForAIPrompt: res.data || [],
        });
      }
    } catch (err) {
      console.log('err', err);
    }

  }

  render() {
    const { assrep_posted, showMoreCommentsModal, assrep_main_comment_visible, showAssessmentLogs, assrepDomainAreaNotesModal, assrepDomainAreaNotesData, assrepDomainAreaNotes, working, printPDFModal, assrep_main_comment_visible_modal } = this.state;
    const { Assrep, AssrepHeader, childData, AssrepMain } = this.props.data;
    const { child_id, child_name, parent_id, parent_name, birth_date } = childData;
    const { assrep_id, assrep_report_type } = Assrep;
    const { assrep_main_id, assrepheader_id } = AssrepMain;

    const { authData } = this.props;
    const { auth_key } = authData.loginData;
    const { center_uuid } = authData.centerData;

    var qs_obj = {
      assrep_id,
      assrepheader_id,
      assrep_main_id,
      auth_key,
      center_uuid,
      lang: this.props.defaultLanguage.lang_abv,
    };
    let qs = ''
    let qs2 = ''
    if (assrep_report_type == 'Detailed Observation') {
      qs = apiURL + 'pdfgenerator/assessment-detail-observation?' + new URLSearchParams(qs_obj).toString()
      qs2 = 'pdfgenerator/assessment-detail-observation'
    }
    if (assrep_report_type == 'Summary Observation') {
      qs = apiURL + 'pdfgenerator/assessment-summary-observation?' + new URLSearchParams(qs_obj).toString();
      qs2 = 'pdfgenerator/assessment-summary-observation'
    }
    if (assrep_report_type == 'Learning Journal') {
      qs = apiURL + 'pdfgenerator/assessment-learning-journal?' + new URLSearchParams(qs_obj).toString();
      qs2 = 'pdfgenerator/assessment-learning-journal'
    }
    if (assrep_report_type == 'EY Report 1') {
      qs = apiURL + 'pdfgenerator/ey-report-1?' + new URLSearchParams(qs_obj).toString();
      qs2 = 'pdfgenerator/ey-report-1'
    }
    if (assrep_report_type == 'EY Report 2') {
      qs = apiURL + 'pdfgenerator/ey-report-2?' + new URLSearchParams(qs_obj).toString();
      qs2 = 'pdfgenerator/ey-report-2'
    }
    if (assrep_report_type == 'EY Report 3') {
      qs = apiURL + 'pdfgenerator/ey-report-3?' + new URLSearchParams(qs_obj).toString();
      qs2 = 'pdfgenerator/ey-report-3'
    }
    if (assrep_report_type == 'Progress Report') {
      qs = apiURL + 'pdfgenerator/ib-report?' + new URLSearchParams(qs_obj).toString();
      qs2 = 'pdfgenerator/ib-report'
    }

    /****************************************************/
    /*       Dynamic Prompt for AI: Domain/Area         */
    /****************************************************/
    let dynamicAIPrompt = `DATA: Child Name: ${child_name}, Child DOB: ${birth_date}, Curriculum: ${assrepDomainAreaNotes.progass_id.label}, Learn Area: ${assrepDomainAreaNotes.learnarea_id.learnarea_desc || assrepDomainAreaNotes.learnarea_id.learnarea_code}. `;

    if (this.state.objectivesForAIPrompt.length > 0) {
      dynamicAIPrompt += `Objectives: ${this.state.objectivesForAIPrompt.map(obj => obj.curriculum_code + ' (' + obj.assmt_code + ')').join(', ')}. `;
    }

    return (
      <Card className='ass-rep-card'>
        <Card.Body>
          <div className='d-flex flex-row align-items-center justify-content-between'>
            <div className='d-flex flex-row align-items-center'>
              <div className='d-flex flex-row align-items-center me-2'>
                <div className='me-1'>
                  <Button variant='success' title={qs} onClick={() => window.open(qs, "PDF" + "_" + assrep_report_type + "_" + assrepheader_id + "_" + assrep_id)}>
                    <FontAwesomeIcon icon={faPrint} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
                  </Button>
                  {/* <Button variant='success' onClick={() => this.printReport(qs2, 'workingEmail')}>
                    <FontAwesomeIcon icon={faPrint} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
                  </Button> */}
                </div>
                <div className='me-1'>
                  <Button variant='info' disabled={this.state.workingEmail} onClick={() => this.emailReport(qs2, 'workingEmail')}>
                    {this.state.workingEmail
                      ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' /> :
                      <FontAwesomeIcon icon={faEnvelopeOpenText} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
                    }
                  </Button>
                </div>
                <div >
                  <Button variant={(assrep_posted === null) ? 'outline-danger' : 'outline-primary'} onClick={() => this.postingToggle()}>
                    <FontAwesomeIcon icon={faCheckDouble} title={(assrep_posted === null) ? '' : moment(assrep_posted).format('DD-MM-YYYY HH:mm:ss')} />
                  </Button>
                </div>
              </div>
              <div style={{ fontSize: 16, fontWeight: '600' }}>{child_name}</div>
            </div>
            <div className='d-flex flex-row align-items-center'>
              <div className='me-1'>
                <Button variant={'outline-primary'} active={showMoreCommentsModal} onClick={() => this.getAssrepDetails()}>
                  <div className='d-flex flex-row align-items-center'>
                    Comments
                    <div className='d-flex flex-row justify-content-between align-items-center ms-1' style={{ borderRadius: '100px', backgroundColor: '#0d6efd', color: '#fff', padding: '3px 4px' }}>
                      <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                  </div>
                </Button>
              </div>
              <div className='me-1'>
                <Button variant={'outline-success'} active={assrep_main_comment_visible_modal} onClick={() => this.setState({ assrep_main_comment_visible_modal: !this.state.assrep_main_comment_visible_modal, showMoreCommentsModal: false, showAssessmentLogs: false, assrepDomainAreaNotesModal: false })}>
                  <div className='d-flex flex-row align-items-center'>
                    Other Comments
                    <div className='d-flex flex-row justify-content-between align-items-center ms-1' style={{ borderRadius: '100px', backgroundColor: '#198754', color: '#fff', padding: '3px 4px' }}>
                      <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                  </div>
                </Button>
              </div>
              <div className='me-1'>
                <Button variant={'outline-danger'} active={showAssessmentLogs} onClick={() => this.state.showAssessmentLogs ? this.setState({ showAssessmentLogs: false, showMoreCommentsModal: false, assrep_main_comment_visible_modal: false, assrepDomainAreaNotesModal: false }) : this.getAssesslogData()}>
                  <div className='d-flex flex-row align-items-center'>
                    Assessments
                    <div className='d-flex flex-row justify-content-between align-items-center ms-1' style={{ borderRadius: '100px', backgroundColor: '#dc3545', color: '#fff', padding: '3px 4px' }}>
                      <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                  </div>
                </Button>
              </div>
              <div className='me-1'>
                <Button variant={'warning'} active={showAssessmentLogs} onClick={() => this.setState({ showAssessmentLogs: false, showMoreCommentsModal: false, assrep_main_comment_visible_modal: false, assrepDomainAreaNotesModal: true }, () => this.GetAssrepDomainAreaNotes())}>
                  <div className='d-flex flex-row align-items-center'>
                    Domain/Area Notes
                    <div className='d-flex flex-row justify-content-between align-items-center ms-1'>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </div>
                  </div>
                </Button>
              </div>
            </div>
          </div>

          {(this.state.assrep_main_comment_visible_modal) &&
            <div className='mt-2'>
              <div className='d-flex flex-column justify-content-between align-items-center p-1' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 10, flex: 1 }}>
                <div className='d-flex flex-row justify-content-end align-items-end p-1' style={{ width: '100%' }}>
                  <Form.Check
                    type="switch"
                    label={t('Show Comments on Report')}
                    onChange={() => this.setState({ assrep_main_comment_visible: !this.state.assrep_main_comment_visible })}
                    checked={this.state.assrep_main_comment_visible}
                  />
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center p-1' style={{ width: '100%' }}>
                  <div className="px-1" style={{ flex: 1 }}>
                    <Form.Group>
                      <Form.Label>{t('Comment 1')}</Form.Label>
                      <Form.Control as="textarea" rows={3}
                        defaultValue={this.state.assrep_main_comment_1}
                        onBlur={(e) => this.setState({ assrep_main_comment_1: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                  <div className="px-1" style={{ flex: 1 }}>
                    <Form.Group>
                      <Form.Label>{t('Comment 2')}</Form.Label>
                      <Form.Control as="textarea" rows={3}
                        defaultValue={this.state.assrep_main_comment_2}
                        onBlur={(e) => this.setState({ assrep_main_comment_2: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                  <div className="px-1" style={{ flex: 1 }}>
                    <Form.Group>
                      <Form.Label>{t('Comment 3')}</Form.Label>
                      <Form.Control as="textarea" rows={3}
                        defaultValue={this.state.assrep_main_comment_3}
                        onBlur={(e) => this.setState({ assrep_main_comment_3: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                  <div className="px-1" style={{ flex: 1 }}>
                    <Form.Group>
                      <Form.Label>{t('Comment 4')}</Form.Label>
                      <Form.Control as="textarea" rows={3}
                        defaultValue={this.state.assrep_main_comment_4}
                        onBlur={(e) => this.setState({ assrep_main_comment_4: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-row justify-content-end mt-2'>
                <Button variant='success' disabled={this.state.working || !this.state.assrep_main_comment_visible_modal}
                  onClick={() => this.updateAssrep()}>
                  {this.state.working
                    ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' className='me-1' />
                    : <FontAwesomeIcon icon={faSave} color={brand_colors[this.props.defaultTheme.theme_id].color8} className='me-1' />
                  }
                  {t('Save')}
                </Button>
              </div>
            </div>
          }
          {this.state.showAssessmentLogs &&
            <div className='mt-1'>
              {this.state.working_assess_logs ? (
                <Row className='text-center'>
                  <Col className='d-flex align-items-center justify-content-center'>
                    <Spinner
                      as='span'
                      animation='grow'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                    {t('Fetching Assessments Logs...')}
                  </Col>
                </Row>
              ) : (
                <>
                  {(this.state.assessLogs.length > 0)
                    ? this.state.assessLogs.map((log, log_i) => <AssessLogRow key={log_i} data={log} />)
                    : <Row className='text-center'>
                      <Col className='d-flex align-items-center justify-content-center'>
                        {t('No Assessment Logs Found')}
                      </Col>
                    </Row>
                  }
                </>
              )}
              <Paginate
                limit={this.state.assessLogslimit}
                totalRecords={this.state.assessLogsTotalRecords}
                pageChange={this.getAssesslogData}
              />
            </div>
          }
          {this.state.showMoreCommentsModal &&
            <div className='mt-2'>

              {!this.state.moreComments &&
                <Row className='flex-column text-center'>
                  <Col>
                    <Spinner
                      as='span'
                      animation='grow'
                      size='lg'
                      role='status'
                      aria-hidden='true'
                      className='mb-1'
                    />
                  </Col>
                  <Col>
                    {t('Fetching comments...')}
                  </Col>
                </Row>
              }
              {this.state.moreComments && this.state.moreComments.length == 0 &&
                <Row className='flex-column text-center'>
                  <Col>
                    {t('No Comments Found')}
                  </Col>
                </Row>
              }
              {this.state.moreComments && this.state.moreComments.length > 0 && this.state.moreComments.map((comment, ci) => (

                <div className='p-1 d-flex flex-column my-1' style={{ border: 'solid 1px ' + brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 10 }}>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                      <div className='me-1'>
                        <Button variant='info' onClick={() => this.delComment(ci)}>
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                      </div>
                      <div>{'Comment ' + (ci + 1)}</div>
                    </div>
                    <div>
                      <Button variant='info' onClick={() => {
                        let new_moreComments = this.state.moreComments
                        new_moreComments[ci].open = !new_moreComments[ci].open
                        this.setState({ moreComments: new_moreComments })
                      }}>
                        <FontAwesomeIcon icon={(comment.open) ? faAngleUp : faAngleDown} />
                      </Button>
                    </div>
                  </div>
                  {(comment.open) &&
                    <div className='mt-1'>
                      <CKEditor
                        key={ci}
                        config={{
                          ckfinder: {
                            uploadUrl: apiURL + '/authentication/ckeditor-upload?auth_key=' + auth_key
                          },
                          removePlugins: ['Title'],
                          toolbar: {
                            items: [
                              'heading',
                              '|',
                              'bold',
                              'italic',
                              'alignment',
                              '|',
                              'numberedList',
                              'bulletedList',
                              '|',
                              'indent',
                              'outdent',
                              '|',
                              'link',
                              'blockQuote',
                              'imageUpload',
                              'insertTable',
                              '|',
                              'undo',
                              'redo'
                            ]
                          }
                        }}
                        editor={Editor}
                        data={this.state.moreComments[ci].assrep_detail_comment}
                        onChange={(
                          event,
                          editor
                        ) => {
                          const data = editor.getData();
                          const moreComments = [...this.state.moreComments];
                          moreComments[ci].assrep_detail_id = comment.assrep_detail_id
                          moreComments[ci].assrep_detail_comment = data
                          this.setState({ moreComments });
                        }}
                      />
                    </div>
                  }
                </div>


                // <div className='mb-3 position-relative'>
                //   <Button variant='danger' style={{ position: 'absolute', top: 0, right: 0, zIndex: 99999, height: 39, borderRadius: 0 }} onClick={() => this.delComment(ci)}>
                //     <FontAwesomeIcon icon={faTrash} color={brand_colors[this.props.defaultTheme.theme_id].color8} />
                //   </Button>
                //   <CKEditor
                //     key={ci}
                //     config={{
                //       ckfinder: {
                //         uploadUrl: apiURL + '/authentication/ckeditor-upload?auth_key=' + auth_key
                //       },
                //       removePlugins: ['Title'],
                //       toolbar: {
                //         items: [
                //           'heading',
                //           '|',
                //           'bold',
                //           'italic',
                //           'alignment',
                //           '|',
                //           'numberedList',
                //           'bulletedList',
                //           '|',
                //           'indent',
                //           'outdent',
                //           '|',
                //           'link',
                //           'blockQuote',
                //           'imageUpload',
                //           'insertTable',
                //           '|',
                //           'undo',
                //           'redo'
                //         ]
                //       }
                //     }}
                //     style={{ height: 200 }}
                //     editor={Editor}
                //     data={this.state.moreComments[ci].assrep_detail_comment}
                //     onChange={(
                //       event,
                //       editor
                //     ) => {
                //       const data = editor.getData();
                //       const moreComments = [...this.state.moreComments];
                //       moreComments[ci] = {
                //         assrep_detail_id: comment.assrep_detail_id,
                //         assrep_detail_comment: data
                //       }

                //       this.setState({ moreComments });
                //     }}
                //   />
                // </div>
              ))}

              <div className='d-flex flex-row justify-content-end mt-2'>
                <div className='me-1'>
                  <Button variant='primary' onClick={() => this.addComment()}>
                    <FontAwesomeIcon icon={faPlus} color={brand_colors[this.props.defaultTheme.theme_id].color8} /> {t('Add New Comment')}
                  </Button>
                </div>
                <div>
                  <Button disabled={this.state.working_more_comments} variant='success' onClick={() => this.saveAssrepDetails()}>
                    {this.state.working_more_comments
                      && <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' />
                    }
                    <FontAwesomeIcon icon={faSave} color={brand_colors[this.props.defaultTheme.theme_id].color8} /> {t('Save')}
                  </Button>
                </div>
              </div>
            </div>
          }
        </Card.Body>

        <Modal show={this.state.assrepDomainAreaNotesModal} size='xl'>
          <Modal.Header className='d-block'>
            <Row className='align-items-center'>
              <Col>
                <Modal.Title>{t('Domain/Area') + ' (' + child_name + ')'}</Modal.Title>
              </Col>
              <Col md={'auto'}>
                <AIGenerationButton
                  style={{ paddingLeft: 5 }}
                  disabled={!(assrepDomainAreaNotes.progass_id && assrepDomainAreaNotes.learnarea_id)}
                  dynamicAIPrompt={dynamicAIPrompt} />
              </Col>
              <Col md={'auto'} className='d-flex flex-row justify-content-end'>
                <FontAwesomeIcon className='cursor-pointer' icon={faTimes} onClick={() => this.setState({ assrepDomainAreaNotesModal: false })} color={brand_colors[this.props.defaultTheme.theme_id].color9} style={{ fontSize: 16 }} />
              </Col>
            </Row>
          </Modal.Header>
          {this.state.assrepDomainAreaNotesModal &&
            <Modal.Body>
              <div className='d-flex flex-row'>
                {/* FORM */}
                <div style={{ flex: 1 }}>
                  <div className='d-flex flex-row align-items-center'>
                    <div className='pe-1' style={{ flex: 1 }}>
                      <Select
                        placeholder={t('--Domain--')}
                        options={this.props.progassData}
                        onChange={(event) => this.setState({ assrepDomainAreaNotes: { ...this.state.assrepDomainAreaNotes, progass_id: event } })}
                        value={assrepDomainAreaNotes.progass_id}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />
                    </div>
                    <div className='ps-1' style={{ flex: 1 }}>
                      <Select
                        placeholder={t('--Area--')}
                        options={this.props.learnareaData.filter((v) => v.progass_id == assrepDomainAreaNotes.progass_id.value)}
                        onChange={(event) => this.setState({
                          assrepDomainAreaNotes: {
                            ...this.state.assrepDomainAreaNotes,
                            learnarea_id: event
                          }
                        }, () => this.getAssesslogs())}
                        value={assrepDomainAreaNotes.learnarea_id}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />
                    </div>
                  </div>
                  <div className='mt-1 ck-height-500'>
                    <CKEditor
                      config={{
                        ckfinder: {
                          uploadUrl: apiURL + '/authentication/ckeditor-upload?auth_key=' + auth_key
                        },
                        removePlugins: ['Title'],
                        toolbar: {
                          items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'alignment',
                            '|',
                            'numberedList',
                            'bulletedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'link',
                            'blockQuote',
                            'imageUpload',
                            'insertTable',
                            '|',
                            'undo',
                            'redo'
                          ]
                        }
                      }}
                      // style={{ height: 500 }}
                      editor={Editor}
                      data={assrepDomainAreaNotes.adan_comment}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ assrepDomainAreaNotes: { ...this.state.assrepDomainAreaNotes, adan_comment: data } })
                      }}
                    />
                  </div>
                  <div className='d-flex flex-row justify-content-end mt-2'>
                    <Button variant={(assrepDomainAreaNotes.adan_id === 0) ? 'primary' : 'warning'} onClick={() => this.saveAssrepDomainAreaNotes()}>
                      {(assrepDomainAreaNotes.adan_id === 0)
                        ? 'Save Note'
                        : 'Update Note'
                      }
                      {working &&
                        <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' />
                      }
                    </Button>
                  </div>
                </div>
                {/* LIST */}
                <div style={{ flex: 1, height: '80vh', overflowY: 'auto' }} className='ps-3'>
                  {assrepDomainAreaNotesData.length <= 0 &&
                    <div>{t('No Data found')}</div>
                  }
                  {assrepDomainAreaNotesData.map((v, i) => {
                    return <div className='d-flex flex-column p-2 mb-1' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, borderRadius: 5 }}>
                      <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='d-flex flex-row  align-items-center justify-content-between' style={{ fontSize: 14, fontWeight: 'bold' }}>
                          <div className='' style={{ color: brand_colors[this.props.defaultTheme.theme_id].color18 }}>{v.progass_code}</div>
                          <div className='mx-3' style={{ color: brand_colors[this.props.defaultTheme.theme_id].color18 }}>
                            <FontAwesomeIcon icon={faAngleRight} />
                          </div>
                          <div className='' style={{ color: brand_colors[this.props.defaultTheme.theme_id].color18 }}>{v.learnarea_code}</div>
                        </div>
                        <div className='d-flex flex-row  align-items-center'>
                          <Button variant='warning' size='sm' className='me-1' onClick={() => this.editAssrepDomainAreaNotes(v)}>
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                          <Button variant='danger' size='sm' onClick={() => this.deleteAssrepDomainAreaNotes(v)}>
                            <FontAwesomeIcon icon={faTrashCan} />
                          </Button>
                        </div>
                      </div>
                      <div style={{ fontSize: 14 }} dangerouslySetInnerHTML={{ __html: v.adan_comment }}>
                      </div>
                    </div>
                  })}
                </div>
              </div>
            </Modal.Body>
          }
        </Modal>

        {/* PRINT PDF MODAL */}
        <Modal show={printPDFModal.show} size='xl' onHide={printPDFModal.toggleModal}>
          <Modal.Header className='d-block'>
            <Row className='align-items-center'>
              <Col>
                <Modal.Title>{t('PRINT')}</Modal.Title>
              </Col>
              <Col className='d-flex flex-row justify-content-end'>
                <Button onClick={() => this.generatePDF()}>Download</Button>
              </Col>
            </Row>
          </Modal.Header>
          {printPDFModal.show &&
            <Modal.Body>
              <div className='d-flex flex-row justify-content-center'>
                <div id="printPDFModal" style={{ width: 447 }}>
                  <AssessmentDetailObservation data={printPDFModal.data} />
                </div>
              </div>
            </Modal.Body>
          }
        </Modal>

        <SweetAlert show={this.state.confirmModal.show} warning showCancel confirmBtnText={t('Yes, confirm !')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.confirmModal.action} onCancel={() => this.setState({ confirmModal: { ...this.state.confirmModal, show: false, id: 0, action: () => { } } })} focusCancelBtn>
          {t(this.state.confirmModal.message)}
        </SweetAlert>

      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  selectedClass: state.selectedClass.data,
  children: state.children.list,
  defaultTheme: state.theme.defaultTheme,
  AIContent: state.AIGenerationModal.AIContent,
});

export default connect(mapStateToProps, null)(AssessRepCard);